import React, { useEffect } from "react";

export const useMountEffect = (effect: React.EffectCallback): void =>
  useEffect(effect, []); // eslint-disable-line react-hooks/exhaustive-deps
